import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import "./login.css";
import {
  ValidateInput,
  ValidateEmail,
  validatePassword,
} from "../../components/helpers/validateInput";
import { NotificationManager } from "react-notifications";
import { httpPost } from "../../components/helpers/httpMethods";
import { setLocalItem } from "../../components/helpers/authService";
import { hideLoader, showLoader } from "../../components/helpers/loader";
import swal from "sweetalert";
import Select from "react-select";
import countryList from "react-select-country-list";
import "react-phone-number-input/style.css";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import Logo from "../../assets/images/appLogo.png";
import LogoImg from "../../assets/images/appLogo2V2.png";
import SEO from "../../components/Layout/SEO";

export default function CreateAccount(props) {
  const [userAccount, setUserAccount] = useState({
    companyName: "", firstName: "", lastName: "",
    email: "", password: "",
  });
  const [accountType, SetaccountType] = useState("individual");
  const [emailOptionText, setEmailOptionText] = useState(false);
  const [userCountry, setuserCountry] = useState("");
  const [userNumber, setuserNumber] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [termAndConditionCheck, SettermAndConditionCheck] = useState(false);
  const options = useMemo(() => countryList().getData(), []);

  const [errorInput, setErrorInput] = useState({
    companyName: "", firstName: "", lastName: "", email: "", password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserAccount({ ...userAccount, [name]: value });
    let testValid = name === "email" ? ValidateEmail(value)
      : name === "password" ? validatePassword(value)
      : ValidateInput(value);
    setErrorInput({ ...errorInput, [name]: testValid });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      errorInput.password !== "Looks Good!" ||
      errorInput.email !== "Looks Good!" ||
      errorInput.firstName !== "Looks Good!" ||
      errorInput.lastName !== "Looks Good!"
    ) {
      return NotificationManager.error("Please fill in all fields.");
    }
    if (userCountry === "") return NotificationManager.error("Please select your country.");
    if (!userNumber) return NotificationManager.error("Phone number is required.");
    if (!termAndConditionCheck) {
      return swal({ title: "Oops!", text: "You need to accept our terms of use before you can proceed.", icon: "warning", dangerMode: true });
    }
    showLoader();
    let countryCode = `+${parsePhoneNumber(userNumber).countryCallingCode}`;
    let sliceNum = userNumber.slice(-10);
    const data = {
      type: accountType,
      firstName: userAccount.firstName,
      lastName: userAccount.lastName,
      email: userAccount.email,
      password: userAccount.password,
      emailOpt: emailOptionText,
      country: userCountry.label,
      countryCode,
      phoneNumber: sliceNum,
    };
    let newData = accountType === "corporate" ? { ...data, companyName: userAccount.companyName } : data;
    let res = await httpPost("auth/register_user", newData);
    if (res) {
      if (res.er) { NotificationManager.error(res.er.message); return; }
      hideLoader();
      // Log the new user straight in, exactly as the login page does.
      const checkFrom = localStorage.getItem("comingFromPublicPublication");
      const rediretURL = localStorage.getItem("rediretURL");
      const login = await httpPost("auth/user_login", { email: newData.email, password: newData.password });
      hideLoader();
      if (login && !login.er && login.data && login.data.token) {
        localStorage.setItem("token", login.data.token);
        setLocalItem("user", login.data.user);
        localStorage.setItem("expiredToken", "false");
        NotificationManager.success(
          `Welcome to TNS, ${login.data.user.firstName}! We've sent a confirmation email to ${newData.email}.`
        );
        if (checkFrom === "true") {
          localStorage.setItem("comingFromPublicPublication", "false");
          props.history.push(`/publication/${rediretURL}`);
        } else {
          props.history.push("/");
        }
      } else {
        swal("Account created!", "Please log in with your email and password.", "success")
          .then(() => props.history.push("/login"));
      }
      return;
    }
    hideLoader();
  };

  return (
    <>
      <SEO
        title="TheNewspaperStand (TNS) | Sign Up"
        description="Create a free TNS account to access digital Nigerian newspapers and magazines."
        url="https://newstand.tech/create_account"
      />
      <div className="login-wrap-v2">

        {/* LEFT PANEL */}
        <div className="login-wrap-v2-col1">
          <div className="login-col1-top">
            <img src={LogoImg} alt="TNS Logo" className="login-col1-logo" />
          </div>
          <div className="heroTextSection">
            <h1>Join <span>50,000+</span><br />Nigerian Readers</h1>
            <ul className="hero-bullets">
              <li>Free to sign up — no credit card needed</li>
              <li>Access 500+ publications instantly</li>
              <li>Read on any device, anywhere</li>
              <li>80% cheaper than print</li>
              <li>Your personal e-library, forever</li>
            </ul>
            <Link to="/login">
              <button className="hero-cta-btn">Sign In instead</button>
            </Link>
          </div>
          <div className="login-col1-badge">
            <p><strong>Nigeria's #1</strong> Digital Newsstand — trusted since 2020</p>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="login-wrap-v2-col2">
          <div className="login-top-bar">
            <Link to="/" className="login-back-btn">← Back to Home</Link>
            <div className="signUpOptonLogin">
              <p>Already have an account? <span><Link to="/login">Sign In</Link></span></p>
            </div>
          </div>

          <div className="mobileViewLogoV2">
            <img src={Logo} alt="TNS Logo" />
          </div>

          <div className="login-wrapv2-main" style={{ maxWidth: "500px" }}>
            <h1 className="login-txt-header">Create Account</h1>
            <p className="login-subheader">Join TNS and start reading today</p>

            <form>
              {/* Account Type */}
              <div className="account-type-v2">
                <button
                  type="button"
                  className={`type-btn ${accountType === "individual" ? "type-btn-active" : ""}`}
                  onClick={() => SetaccountType("individual")}
                >Individual</button>
                <button
                  type="button"
                  className={`type-btn ${accountType === "corporate" ? "type-btn-active" : ""}`}
                  onClick={() => SetaccountType("corporate")}
                >Corporate</button>
              </div>

              {/* Corporate only */}
              {accountType === "corporate" && (
                <div className="inputWrap-v2">
                  <label>Company Name</label>
                  <input name="companyName" onChange={handleChange} placeholder="Enter company name" type="text" value={userAccount.companyName} />
                </div>
              )}

              {/* Name row */}
              <div className="input-row-v2">
                <div className="inputWrap-v2">
                  <label>First Name</label>
                  <input name="firstName" onChange={handleChange} placeholder="First name" type="text" value={userAccount.firstName} />
                </div>
                <div className="inputWrap-v2">
                  <label>Last Name</label>
                  <input name="lastName" onChange={handleChange} placeholder="Last name" type="text" value={userAccount.lastName} />
                </div>
              </div>

              <div className="inputWrap-v2">
                <label>Email Address</label>
                <input name="email" onChange={handleChange} placeholder="Enter your email address" type="text" value={userAccount.email} />
              </div>

              <div className="inputWrap-v2">
                <label>Mobile Number</label>
                <div className="phone-input-v2">
                  <PhoneInput defaultCountry="NG" placeholder="Enter phone number" value={userNumber} onChange={setuserNumber} />
                </div>
              </div>

              <div className="inputWrap-v2">
                <label>Country</label>
                <div className="select-v2">
                  <Select options={options} value={userCountry} onChange={setuserCountry} placeholder="Select your country" />
                </div>
              </div>

              <div className="inputWrap-v2">
                <label>Password</label>
                <div style={{ position: "relative" }}>
                  <input
                    name="password"
                    onChange={handleChange}
                    placeholder="Create a password"
                    type={showPass ? "text" : "password"}
                    value={userAccount.password}
                    style={{ paddingRight: "44px" }}
                  />
                  <i
                    onClick={() => setShowPass(!showPass)}
                    className={`fas ${showPass ? "fa-eye" : "fa-eye-slash"}`}
                    style={{ position: "absolute", right: "14px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#ee7f0d", fontSize: "16px" }}
                  />
                </div>
              </div>

              {/* Checkboxes */}
              <div className="checkbox-group-v2">
                <label className="checkbox-label-v2">
                  <input type="checkbox" onClick={() => setEmailOptionText(!emailOptionText)} />
                  <span>Send me updates on new issues and topic trends</span>
                </label>
                <label className="checkbox-label-v2">
                  <input type="checkbox" checked={termAndConditionCheck} onClick={() => SettermAndConditionCheck(!termAndConditionCheck)} onChange={() => {}} />
                  <span>
                    I agree to the{" "}
                    <a href="https://thenewspaperstand.com/terms-conditions/" target="_blank" rel="noreferrer">TNS Terms & Conditions</a>
                    {" "}and{" "}
                    <a href="https://thenewspaperstand.com/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>
                  </span>
                </label>
              </div>

              <div className="loginBtnV2" style={{ marginTop: "24px", marginBottom: "20px" }}>
                <button onClick={handleSubmit}>Create my account</button>
              </div>

              <div className="haveanAccountV2Op">
                <p>Already have an account? <Link to="/login">Sign In</Link></p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
